import axios from 'axios';
import {MAX_IMG_SIZE} from '../constants';
import i18n from '../i18n';
import {formatBytes} from './utils';

export class ImageSizeLimitError extends Error {
    constructor(public readonly maxSize: number) {
        super('Image size exceeds the upload limit');
        this.name = 'ImageSizeLimitError';
    }
}

export function validateImageSize(size: number): void {
    if (size > Number(MAX_IMG_SIZE)) throw new ImageSizeLimitError(Number(MAX_IMG_SIZE));
}

export function getImageSizeErrorMessage(error: unknown): string | undefined {
    let maxSize: number | undefined;
    if (error instanceof ImageSizeLimitError) {
        maxSize = error.maxSize;
    } else if (axios.isAxiosError<{code?: string; maxSize?: number}>(error) && error.response?.data?.code === 'IMAGE_TOO_LARGE') {
        maxSize = error.response.data.maxSize;
    }
    if (maxSize === undefined) return undefined;

    return `${i18n.t('presEditPage.editSidebar.validation.imageSize')} ${i18n.t(
        'presEditPage.editSidebar.validation.maxSize'
    )} ${formatBytes(maxSize, 1, true)}`;
}
